import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import AuthorSocialCircleModal from '../AuthorSocialCircleModal';
import cx from '../../../styles';

class AuthorNetworkInfoComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {isModalOpen: false, mode: ''};
    }

    openModal = (mode, count) => {
        count > 0 && this.setState({isModalOpen: true, mode: mode});
    }

    onModalClose = () => {
        this.setState({isModalOpen: false});
    }

    render() {
        const { author, t } = this.props;

        return (
            author.is_blocked === 0 && 
            <div className={cx("author-network-info-component")}>
                <div className={cx("network")}>
                    <h3 className={cx('not-mobile')}>{t('profile_highlights')}</h3>
                    <div className={cx("follow-wrap")}>
                        <div className={cx(author.follow_count > 0 ? "pointer-click" : "")} onClick={()=>this.openModal('followers', author.follow_count)}>
                            <div>{author.follow_count_nice}</div>
                            <div>{t('profile_follower')}</div>
                        </div>
                        <div className={cx(author.following_count > 0 ? "pointer-click" : "")} onClick={()=>this.openModal('following', author.following_count)}>
                            <div>{author.following_count_nice}</div>
                            <div>{t('profile_following')}</div>
                        </div>
                    </div>
                </div>

                {/*<div className={cx("highlights")}>
                    <h3>{t('profile_highlights')}</h3>
                    <div>
                        <p>
                            {author.answers_posted}
                            <span> {t('profile_tab_reply')}</span>
                        </p>
                        <p>
                            {author.questions_asked}
                            <span> {t('profile_tab_post')}</span>
                        </p>
                        <div className={cx("clear-fix")}></div>
                     </div>
                </div>*/}

                <AuthorSocialCircleModal isModalOpen={this.state.isModalOpen}
                    mode={this.state.mode}
                    userId={author.id}
                    onModalClose={this.onModalClose} 
                    t={t} />

            </div>
        );
    }

}

export default translate()(AuthorNetworkInfoComponent);
